import { DateIcon, HidePasswordIcon, ShowPasswordIcon } from "Components/icons/Icons";
import { useId } from "react";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import PhoneInput from "react-phone-number-input";

export default function FieldRenderer({ className,
    field,
    errors,
    handleInputChange,
    handlePress,
    modalType,
    showPassword,
    setShowPassword,
    showConfirmPassword,
    setShowConfirmPassword,
    withLabel = false, // default giữ nguyên cũ

}) {

    // console.log({ errors, field })
    const id = useId(); // React hook tạo unique id cho mỗi render
    //tw-border-[#dee2e6]
    const baseInputClass = `form-control
     tw-appearance-none tw-h-[50px] tw-pl-[30px] tw-my-1 tw-box-border tw-flex tw-flex-row tw-items-center tw-p-3 tw-gap-2 tw-bg-white tw-border tw-border-[#F0F1F3] sm:tw-border-[#63abad] tw-rounded-[12px] sm:tw-rounded-[50px]
     ${field.error ? "tw-border-[#dc3545]" : "tw-border-[#D1D5DB]"} `;


    const inputRender = () => {

        // logic render từng type
        if (field.key === "contact_details" || field.key === "phone_number") {
            return (
                <>
                    <PhoneInput
                        placeholder={field.placeholder}
                        name={field.key}
                        value={field.value}
                        className={baseInputClass}
                        // className="form-control tw-h-[50px] tw-pl-[30px]
                        // tw-my-1
                        // tw-box-border tw-flex tw-flex-row tw-items-center tw-p-3 tw-gap-2 tw-bg-white tw-border tw-border-[#F0F1F3] sm:tw-border-[#63abad] tw-rounded-[12px] sm:tw-rounded-[50px]"
                        onChange={(event) => handleInputChange(event)}
                    // defaultCountry="DE"
                    />
                    {/* <small className="text-muted">Select your country then add number without code</small> */}
                </>
            );
        }

        if (field.key === "company_address" || field.key === "address") {
            return (
                <GooglePlacesAutocomplete
                    // className={ className={baseInputClass}} // not work => style
                    apiKey="AIzaSyD7bv-x9cb4Dw90PPk8jGchL0-miIVyxSI"
                    selectProps={{
                        placeholder: field.placeholder,
                        value: field.value?.formatted_address,
                        onChange: (event) => handleInputChange(event.label, "address"),
                        styles: {
                            singleValue: (provided) => ({
                                ...provided,
                                color: 'black',
                            }),
                            control: (baseStyles, state) => ({
                                ...baseStyles,
                                borderRadius: window.innerWidth < 640 ? "12px" : "30px", // sm breakpoint
                                padding: '6px',
                                paddingLeft: '15px',
                                borderColor: window.innerWidth < 640 ? "#F0F1F3" : "#549aa4", //#549aa4
                                // opacity: 0.5,
                                // backgroundColor: '#fff'
                                background: '#fff',
                                marginTop: '0.25rem',
                                marginBottom: '0.25rem',
                            }),
                        },
                        //
                        // classNames: {
                        //     control: () =>
                        //         "tw-box-border tw-flex tw-flex-row tw-items-center tw-p-3 tw-gap-2 tw-bg-white tw-border tw-border-[#F0F1F3] tw-rounded-[12px] sm:tw-rounded-[50px]",
                        // },
                    }}


                />
            );
        }

        if (field.type === "select") {
            return (
                <select
                    name={field.key}
                    value={field.value}
                    className={baseInputClass}
                    // className="form-control tw-h-[50px] tw-pl-[30px]
                    //         tw-my-1 tw-box-border tw-flex tw-flex-row tw-items-center tw-p-3 tw-gap-2 tw-bg-white tw-border tw-border-[#F0F1F3] sm:tw-border-[#63abad] tw-rounded-[12px] sm:tw-rounded-[50px]"
                    onChange={(event) => handleInputChange(event)}
                >
                    <option value="" disabled>
                        {field.placeholder}
                    </option>
                    {field.options.map((opt, i) => (
                        <option key={i} value={opt}>
                            {opt}
                        </option>
                    ))}
                </select>
            );
        }

        return (
            <>
                <input
                    id={id}
                    type={
                        (field.key === "password" && showPassword) ||
                            (field.key === "password_confirmation" && showConfirmPassword)
                            ? "text"
                            : field.type
                    }
                    name={field.key}
                    value={field.value}
                    className={baseInputClass}
                    // className="form-control
                    //     tw-h-[50px] tw-pl-[30px]
                    //     tw-my-1 tw-appearance-none
                    //     tw-box-border tw-flex tw-flex-row tw-items-center tw-p-3 tw-gap-2 tw-bg-white tw-border tw-border-[#F0F1F3] sm:tw-border-[#63abad] tw-rounded-[12px] sm:tw-rounded-[50px] "
                    placeholder={field.placeholder}
                    onChange={(event) => handleInputChange(event, field.key)}
                    onKeyUp={(event) => {
                        if (field.key === "password_confirmation" && event.key === "Enter") {
                            event.preventDefault();
                            handlePress(modalType);
                        }
                    }}
                />

                {(field.type === "date") && <span className="tw-absolute tw-right-3 tw-top-[62%] tw--translate-y-1/2 tw-text-gray-500"
                    onClick={() => document.getElementById(id).showPicker?.()}
                >
                    {/* 📅 */}
                    <DateIcon />
                </span>}


                {(field.key === "password" || field.key === "password_confirmation") && (
                    <div
                        className="tw-absolute tw-top-9 sm:tw-top-[1.1rem] tw-right-5"
                        onClick={() =>
                            field.key === "password"
                                ? setShowPassword(!showPassword)
                                : setShowConfirmPassword(!showConfirmPassword)
                        }
                    >
                        {/* desktop */}
                        <img
                            className="tw-hidden sm:tw-block"
                            src={
                                field.key === "password"
                                    ? showPassword
                                        ? "/assets/images/show_password.svg"
                                        : "/assets/images/hide_password.svg"
                                    : showConfirmPassword
                                        ? "/assets/images/show_password.svg"
                                        : "/assets/images/hide_password.svg"
                            }
                            alt="toggle-password"
                        />
                        {/* mobile */}
                        <div className="tw-block sm:tw-hidden">
                            {field.key === "password" ? (
                                showPassword ? <ShowPasswordIcon /> : <HidePasswordIcon />
                            ) : (
                                showConfirmPassword ? <ShowPasswordIcon /> : <HidePasswordIcon />
                            )}
                        </div>
                    </div>
                )}

                {/* {field.type === "email" && (
                    <small className="form-text ps-4 phoneFont
                  tw-hidden sm:tw-block
                  ">We'll never share your email with anyone else.</small>
                )} */}

                {/* {field.error && <small className="ms-4 text-danger">{field.error}</small>} */}

                {/* {field.error && <small className="ms-2 text-danger">{field.error}</small>} */}
            </>
        );
    }

    return <>
        <div className={className}>
            {withLabel && field.label && (
                <label className="tw-block sm:tw-hidden tw-mb-1 tw-text-[14px] tw-font-normal tw-text-[#4B5463] tw-leading-[18px]">
                    {field.label}
                    {field.required && <span className="tw-text-[#ED4245] tw-ml-2">*</span>}
                </label>
            )}
            {field.helperText && (
                <div className="ps-md-4 text-sm-center text-md-start
                tw-hidden sm:tw-block
                tw-absolute tw-top-[-25px]
                ">
                    <small className="ps-md-2">{field.helperText}</small>
                </div>
            )}
            {inputRender()}

            {field.helperTextBottom && <small className="form-text ps-4 phoneFont
                  tw-hidden sm:tw-block
                  ">{field.helperTextBottom}</small>}

            {/* {field.type === "email" && (
                    <small className="form-text ps-4 phoneFont
                  tw-hidden sm:tw-block
                  ">We'll never share your email with anyone else.</small>
                )} */}
            {field.error && <small className="ms-2 text-danger">{field.error}</small>}
        </div>
    </>

}
